import React, { useState } from "react";
import { Link } from "react-router-dom";
import BuyPlan from "./PlanPurchase/BuyPlan";
import { useEffect } from "react";

const LandingPage = () => {
  const [openPopup, setOpenPopup] = useState(false);
  const [planCode, setPlanCode] = useState("");
  const [tenantId, setTenantId] = useState("T1046001XT4");

  const COLORS = {
    primary: "#0B3C5D",
    secondary: "#4CAF50",
    accent: "#8BC34A",
    lightBg: "#F4F9F6",
  };

  const testimonials = [
  {
    id: 1,
    name: "Karan Singh",
    location: "Chandigarh",
    image: "assets/images/subpartner/kashish.png",
    rating: 5,
    role: "Working Professional",
    message:
      "Managing my family’s health is now much easier. From consultations to tests, everything is accessible and affordable, making it perfect for families.",
  },
  {
    id: 2,
    name: "Sneha Gupta",
    location: "Jaipur",
    image: "assets/images/subpartner/shreya.png",
    rating: 5,
    role: "Homemaker",
    message:
      "What impressed me most is how affordable yet reliable these plans are. I no longer worry about medical expenses, and everything is smooth and hassle-free without compromising on quality care.",
  },
  {
    id: 3,
    name: "Vikram Mehta",
    location: "Bangalore",
    image: "assets/images/subpartner/vishal.png",
    rating: 5,
    role: "Frequent Traveler",
    message:
      "Since I travel frequently, having access to healthcare anytime and anywhere gives me real peace of mind. The convenience and reliability make it a must-have for my busy lifestyle"
  },
  {
    id: 4,
    name: "Pooja Verma",
    location: "Delhi",
    image: "assets/images/subpartner/preeti.png",
    rating: 5,
    role: "Mother of Two",
    message:
      "With kids at home, healthcare needs are constant, and this plan makes everything smooth and stress-free. It’s reassuring to have quality care always within reach for my family.",
  },
];

  const plans = [
    {
      title: "Spekctrum Initial Plan",
      desc: "Member Coverage: Individual",
      price: "₹999 ",
      code: "TruvanaSpekctrumInitial",
      features: [
        "2 calls Per Month Tele Doctor Consultation (GP)",
        "Upto 50% off on 2 credits Full Body Checkup (91 Parameters)",
        "Upto 20% off on ₹ 50,000 Pharmacy Wallet - Prescribed Medicines",
        "1 Credit Health Wellness Virtual Consultation",
        "Unlimited Vital via Face Scan",
        {
          "Group Personal Accidental Rider (Only For Primary Member)": [
            "₹15 Lakhs Sum Insured",
            "Covered Accidental Death",
            "Covered Permanent Total Disability (Upto 100% SI Paid on PTD)",
          ],
          "Inclusive Benefits": [
            "Applicable Risk Assessment",
            "Applicable Health Reminder",
            "Applicable Recorded Fitness sessions",
            "Unlimited Chat with Experts",
          ],
        },
      ],
    },
    {
      title: "Spekctrum Basic Plan",
      desc: "Member Coverage: 2 Adults + 2 Children",
      price: "₹1,999",
      code: "TruvanaSpekctrumBasic",
      features: [
        "2 calls Per Month Tele Doctor Consultation (GP)",
        "Upto 50% off on 2 credits Full Body Checkup (91 Parameters)",
        "Upto 20% off on ₹ 50,000 Pharmacy Wallet - Prescribed Medicines",
        "1 Credit Health Wellness Virtual Consultation",
        "1 Credit 1 Annual Health Checkup - Basic",
        "8 Credits Video Consultation-General Physician",
        "Unlimited Vital via Face Scan",
        {
          "Group Personal Accidental Rider (Only For Primary Member)": [
            "₹15 Lakhs Sum Insured",
            "Covered Accidental Death",
            "Covered Permanent Total Disability (Upto 100% SI Paid on PTD)",
          ],
          "Inclusive Benefits": [
            "Applicable Risk Assessment",
            "Applicable Health Reminder",
            "Applicable Recorded Fitness sessions",
            "Unlimited Chat with Experts",
          ],
        },
      ],
    },
    {
      title: "Spekctrum Value Plan",
      desc: "Member Coverage: 2 Adults + 2 Children",
      price: "₹2,999",
      code: "TruvanaSpekctrumValue",
      features: [
        "8 Credits on Tele Doctor Consultation (GP)",
        "2 Credits on Tele Doctor Consultation Ayurveda",
        "2 Credits on Tele Doctor Consultation Homeopathy",
        "2 Credits on Full Body Checkup (91 Parameters)",
        "10 Credits on Video Consultation-General Physician",
        "2 Credits on Dental Check-Up and Consultation",
        "2 Credits on Mental Wellness",
        {
          "Group Personal Accidental Rider (Only For Primary Member)": [
            "₹15 Lakhs Sum Insured",
            "Covered Accidental Death",
            "Covered Permanent Total Disability (Upto 100% SI Paid on PTD)",
          ],
          "Inclusive Benefits": [
            "Applicable Risk Assessment",
            "Applicable Health Reminder",
            "Applicable Recorded Fitness sessions",
            "Unlimited Chat with Experts",
          ],
        },
      ],
    },
    {
      title: "Spekctrum Value Plus Plan",
      desc: "Member Coverage: 2 Adults + 2 Children",
      price: "₹3,999",
      code: "TruvanaSpekctrumValuePlus",
      features: [
        "12 Credits on Tele Doctor Consultation (GP)",
        "2 Credits on Tele Doctor Consultation Ayurveda",
        "2 Credits on Tele Doctor Consultation Homeopathy",
        "8 Credits on 18+ Specialist Consultation",
        "2 Credits on Full Body Checkup (91 Parameters)",
        "12 Credits on Video Consultation-General Physician",
        "2 Credits on Dental Check-Up and Consultation",
        "2 Credits on Mental Wellness",
        {
          "Group Personal Accidental Rider (Only For Primary Member)": [
            "₹15 Lakhs Sum Insured",
            "Covered Accidental Death",
            "Covered Permanent Total Disability (Upto 100% SI Paid on PTD)",
          ],
          "Inclusive Benefits": [
            "Applicable Risk Assessment",
            "Applicable Health Reminder",
            "Applicable Recorded Fitness sessions",
            "Unlimited Chat with Experts",
          ],
        },
      ],
    },
    {
      title: "Spekctrum Essential Plan",
      desc: "Member Coverage: 2 Adults + 2 Children",
      price: "₹4,999",
      code: "TruvanaSpekctrumEssential",
      features: [
        "12 Credits on Tele Doctor Consultation (GP)",
        "4 Credits on Tele Doctor Consultation Ayurveda",
        "4 Credits on Tele Doctor Consultation Homeopathy",
        "8 Credits on 18+ Specialist Tele Doctor Consultation",
        "2 Credits on Full Body Checkup (91 Parameters)",
        "12 Credits on Video Consultation-General Physician",
        "₹500 Wallets on Diagnostic & Radiology Wallet",
        "1 Credit Health Wellness Virtual Consultation",
         "2 Credits on Dental Check-Up and Consultation",
        "2 Credits on Dietician Consultation",
         "Upto 20% discount on ₹25,000 on Pharmacy Wallet - Prescribed Medicines",
        {
          "Group Personal Accidental Rider (Only For Primary Member)": [
            "₹15 Lakhs Sum Insured",
            "Covered Accidental Death",
            "Covered Permanent Total Disability (Upto 100% SI Paid on PTD)",
          ],
          "Inclusive Benefits": [
            "Applicable Risk Assessment",
            "Applicable Health Reminder",
            "Applicable Recorded Fitness sessions",
            "Unlimited Chat with Experts",
          ],
        },
      ],
    },
  ];

  return (
    <div
      className="overflow-x-hidden mainfont"
      style={{ scrollBehavior: "smooth", background: COLORS.lightBg }}
    >
      <div className="min-h-screen text-slate-900">
        {/* HERO */}
        <div
          className="relative w-full h-[500px] md:h-[650px] text-white flex flex-col"
          style={{
            backgroundImage: `url(/assets/images/subpartner/landing-bg.png)`,
            backgroundSize: "cover",
            backgroundPosition: "center center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div className="w-full max-w-7xl mx-auto px-4 lg:px-8 pt-4 flex justify-between items-center z-10">
            <a href="/">
              <img
                src="http://truvanaopd.com/assets/images/brand_logo.png"
                className="w-[110px] md:w-[150px]"
              />
            </a>
            <a href="/">
              <img
                src="/assets/images/subpartner/spekctrum-logo.png"
                className="w-[110px] md:w-[150px]"
              />
            </a>
          </div>

          <div className="flex-1 flex items-center justify-center text-center px-4">
            <div className="max-w-4xl">
              <h1
                style={{ color: COLORS.primary }}
                className="font-bold leading-tight text-3xl sm:text-5xl md:text-6xl"
              >
                Complete Family Healthcare <br />
                <span className="mt-2" style={{ color: COLORS.secondary }}>
                  Made Simple, Affordable & Reliable
                </span>
              </h1>

              <div className="flex justify-center mt-6">
                <a
                  href="#pricing"
                  className="px-8 py-3 rounded-full text-white font-semibold shadow-lg hover:scale-105 transition"
                  style={{
                    background: `linear-gradient(135deg, ${COLORS.secondary}, ${COLORS.accent})`,
                  }}
                >
                  View Plans
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* FEATURES */}
        <div className="relative z-20 max-w-6xl mx-auto px-4 lg:px-8 -mt-16">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {[
              { label: "Family of 4", icon: "fa-users" },
              { label: "24/7 Doctor", icon: "fa-briefcase-medical" },
              { label: "Medicine Discounts", icon: "fa-pills" },
              { label: "Diagnostic Savings", icon: "fa-microscope" },
            ].map((item, i) => (
              <div
                key={i}
                className="bg-white/80 backdrop-blur-lg rounded-2xl p-5 shadow-md hover:shadow-xl hover:-translate-y-2 transition"
              >
                <div
                  className="w-12 h-12 rounded-xl flex items-center justify-center text-white mb-3"
                  style={{
                    background: `linear-gradient(135deg, ${COLORS.primary}, ${COLORS.secondary})`,
                  }}
                >
                  <i className={`fa-solid ${item.icon}`}></i>
                </div>
                <p className="font-semibold text-18">{item.label}</p>
              </div>
            ))}
          </div>
        </div>

        {/* PRICING */}
        <section
          className="py-16"
          id="pricing"
          style={{ background: COLORS.lightBg }}
        >
          <div className="max-w-6xl mx-auto px-4">
            <div className="text-center mb-12">
              <h2
                className="text-4xl font-bold"
                style={{ color: COLORS.secondary }}
              >
                Plans Available For You
              </h2>
              <p className="text-gray-600 mt-3 text-xl font-semibold"  style={{ color: COLORS.primary }}>
                Affordable plans designed to fit your family.
              </p>
            </div>

            <div className="flex flex-col gap-6">
              {plans.map((plan, i) => (
                <div
                  key={i}
                  className="rounded-3xl p-6 sm:p-10 shadow-md hover:shadow-xl hover:-translate-y-1 transition"
                  style={{
                    background: "linear-gradient(145deg, #fff, #f3f6f9)",
                  }}
                >
                  <div className="flex justify-between flex-wrap gap-6">
                    <div>
                      <h4 className="text-3xl font-semibold" style={{ color: COLORS.secondary }}>{plan.title}</h4>
                      <p className="text-gray-500 text-2xl" style={{ color: COLORS.primary }}>{plan.desc}</p>

                      <div className="mt-3 flex items-center gap-1">
                        <span
                          className="text-3xl font-bold"
                          style={{ color: COLORS.primary }}
                        >
                          {plan.price}
                        </span>
                        <p className="text-lg font-medium text-gray-900 mt-2">+ GST</p>
                      </div>
                    </div>

                    <button
                      onClick={() => {
                        setPlanCode(plan.code);
                        setOpenPopup(true);
                      }}
                      className="flex items-center justify-center w-24 h-10 rounded-full text-white font-semibold hover:scale-105 transition"
                      style={{
                        background: `linear-gradient(135deg, ${COLORS.secondary}, ${COLORS.accent})`,
                      }}
                    >
                      Buy Now
                    </button>
                  </div>

                  <div className="grid sm:grid-cols-2 gap-3 mt-6">
                    {plan.features.map((f, idx) => {
                      if (typeof f === "string") {
                        return (
                          <div
                            key={idx}
                            className="flex gap-2 text-sm items-start"
                          >
                            <span style={{ color: COLORS.secondary }}>✔</span>
                            <span className="text-18">{f}</span>
                          </div>
                        );
                      }

                      if (typeof f === "object" && f !== null) {
                        return (
                          <div
                            key={idx}
                            className="sm:col-span-2 grid sm:grid-cols-2 gap-3 mt-2"
                          >
                            {Object.entries(f).map(([heading, details]) => (
                              <div
                                key={heading}
                                className="rounded-xl p-3 border border-gray-100 bg-white/60"
                              >
                                <p className="text-base font-semibold text-gray-700 mb-2 uppercase tragit cking-wide">
                                  {heading}
                                </p>

                                {Array.isArray(details) &&
                                  details.map((item, i) => (
                                    <div
                                      key={i}
                                      className="flex gap-2 text-sm items-start"
                                    >
                                      <span style={{ color: COLORS.secondary }}>
                                        ✔
                                      </span>
                                      <span className="text-18">{item}</span>
                                    </div>
                                  ))}
                              </div>
                            ))}
                          </div>
                        );
                      }

                      return null;
                    })}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-12" style={{ background: COLORS.lightBg }}>
          <div className="max-w-6xl mx-auto px-4">
            <h2
              className="text-4xl font-bold text-center mb-8"
              style={{ color: COLORS.secondary }}
            >
              Voices of Our Happy Members
            </h2>

            <div className="grid md:grid-cols-2 gap-6">
              {testimonials.map((user) => (
                <div
                  key={user.id}
                  className="bg-white rounded-2xl p-5 shadow-sm hover:shadow-lg transition hover:-translate-y-1"
                >
                  <div className="flex items-center gap-3 mb-3">
                    <img
                      src={user.image}
                      className="w-[60px] h-[60px] rounded-full"
                    />
                    <div>
                      <p className="font-semibold text-lg">{user.name}</p>
                      <p className="text-base text-gray-500">
                        {user.location} • {user.role}
                      </p>
                    </div>
                  </div>

                  <div className="text-yellow-400 mb-2 text-lg">
                    {"★".repeat(user.rating)}
                  </div>

                  <p className="text-gray-600 text-lg">{user.message}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <footer className="pt-10 md:pt-20 bg-[#d4fcd5]">
          <div className="theme-container mx-auto flex flex-wrap justify-between mb-20 gap-5">
            <div className="w-fit max-w-[300px]">
              <img src="assets/images/footer-logo.png" alt="logo" />
              <p className="max-w-[300px] text-[#0B3C5D] my-6">
                We are a movement toward mindful living, conscious choices, and
                natural solutions that restore your body’s true harmony. Truvana
                Health - Wellness in Every Breath
              </p>
            </div>
            <div className="w-fit max-w-[300px]">
              <div className="max-w-[223px]">
                <h1 className="font-semibold text-18 text-[#0B3C5D]">Address</h1>
                <div className="flex gap-2 items-center relative group font-medium text-[#0B3C5D]  transition-all duration-300 mt-3.5">
                  <span className="transition-all duration-300">
                    UGF- 71- Upper Ground Ansal Plaza - 2 Chiranjiv Vihar
                    Ghaziabad ( U P )- 201002
                  </span>
                </div>
                <h1 className="font-semibold text-18 text-[#0B3C5D] mt-6">
                  Contact
                </h1>
                <div className="flex gap-2 items-center relative group font-medium text-[#0B3C5D]  transition-all duration-300 mt-3.5">
                  <span className="transition-all duration-300">
                    <a href="mailto:support@truvanaopd.com">
                      support@truvanaopd.com
                    </a>
                    <br />
                    +91-9211226940
                  </span>
                </div>
              </div>
            </div>
            <div className="w-fit max-w-[300px]">
              <div className="flex flex-col items-center">
                <div>
                  <h1 className="font-semibold text-18 text-[#0B3C5D]">
                    Qwick Links
                  </h1>
                  <ul className="mt-3.5">
                    <li className="mt-2">
                      <Link to="/">
                        <div className="flex gap-2 items-center relative group font-medium text-[#0B3C5D] transition-all duration-300 overflow-hidden">
                          <svg
                            className="absolute -left-2 transition-all duration-300 group-hover:left-0"
                            width="6"
                            height="12"
                            viewBox="0 0 6 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1 1L5 6L1 11"
                              stroke="white"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <span className="group-hover:translate-x-4 transition-all duration-300">
                            Home
                          </span>
                        </div>
                      </Link>
                    </li>
                    <li className="mt-2">
                      <Link to="/plans">
                        <div className="flex gap-2 items-center relative group font-medium text-[#0B3C5D] transition-all duration-300 overflow-hidden">
                          <svg
                            className="absolute -left-2 transition-all duration-300 group-hover:left-0"
                            width="6"
                            height="12"
                            viewBox="0 0 6 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1 1L5 6L1 11"
                              stroke="white"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <span className="group-hover:translate-x-4 transition-all duration-300">
                            Plans
                          </span>
                        </div>
                      </Link>
                    </li>
                    <li className="mt-2">
                      <Link to="/contact">
                        <div className="flex gap-2 items-center relative group font-medium text-[#0B3C5D] transition-all duration-300 overflow-hidden">
                          <svg
                            className="absolute -left-2 transition-all duration-300 group-hover:left-0"
                            width="6"
                            height="12"
                            viewBox="0 0 6 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1 1L5 6L1 11"
                              stroke="white"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <span className="group-hover:translate-x-4 transition-all duration-300">
                            Contact
                          </span>
                        </div>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="w-fit max-w-[300px]">
              <div className="flex flex-col items-center">
                <div>
                  <h1 className="font-semibold text-18 text-[#0B3C5D]">
                    Terms & Policies
                  </h1>
                  <ul className="mt-3.5">
                    <li className="mt-2">
                      <Link to="/term-of-use">
                        <div className="flex gap-2 items-center relative group font-medium text-[#0B3C5D] transition-all duration-300 overflow-hidden">
                          <svg
                            className="absolute -left-2 transition-all duration-300 group-hover:left-0"
                            width="6"
                            height="12"
                            viewBox="0 0 6 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1 1L5 6L1 11"
                              stroke="white"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <span className="group-hover:translate-x-4 transition-all duration-300">
                            Term of Use
                          </span>
                        </div>
                      </Link>
                    </li>
                    <li className="mt-2">
                      <Link to="/privacy-policy">
                        <div className="flex gap-2 items-center relative group font-medium text-[#0B3C5D] transition-all duration-300 overflow-hidden">
                          <svg
                            className="absolute -left-2 transition-all duration-300 group-hover:left-0"
                            width="6"
                            height="12"
                            viewBox="0 0 6 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1 1L5 6L1 11"
                              stroke="white"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <span className="group-hover:translate-x-4 transition-all duration-300">
                            Privacy Policy
                          </span>
                        </div>
                      </Link>
                    </li>
                    <li className="mt-2">
                      <Link to="/cancellation-policy">
                        <div className="flex gap-2 items-center relative group font-medium text-[#0B3C5D] transition-all duration-300 overflow-hidden">
                          <svg
                            className="absolute -left-2 transition-all duration-300 group-hover:left-0"
                            width="6"
                            height="12"
                            viewBox="0 0 6 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1 1L5 6L1 11"
                              stroke="white"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <span className="group-hover:translate-x-4 transition-all duration-300">
                            Cancellation Policy
                          </span>
                        </div>
                      </Link>
                    </li>
                    <li className="mt-2">
                      <Link to="/shipping-delivery-policy">
                        <div className="flex gap-2 items-center relative group font-medium text-[#0B3C5D] transition-all duration-300 overflow-hidden">
                          <svg
                            className="absolute -left-2 transition-all duration-300 group-hover:left-0"
                            width="6"
                            height="12"
                            viewBox="0 0 6 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1 1L5 6L1 11"
                              stroke="white"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <span className="group-hover:translate-x-4 transition-all duration-300">
                            Shipping And Delivery Policy
                          </span>
                        </div>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full h-[80px] md:h-[65px] bg-[#b8edba]">
            <div className="theme-container mx-auto h-full">
              <div className="w-full h-full flex flex-wrap justify-between items-center">
                <span className="text-[#0B3C5D] max-w-100">
                  2025 © All rights reserved by &nbsp;
                  <b className="text-[#0B3C5D]">Truvana Health</b>
                </span>
                <div className="relative w-full sm:w-fit flex justify-center">
                  <a
                    href="#top"
                    aria-label="go top"
                    className="w-[45px] h-[45px] rounded-full border-[3px] border-[#323239] flex justify-center items-center bg-blue-sass absolute -top-[75px] sm:-top-[55px] max-[768px]:right-0"
                  >
                    <span>
                      <svg
                        width="45"
                        height="45"
                        viewBox="0 0 45 45"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="22.5"
                          cy="22.5"
                          r="21"
                          fill="#0B3C5D"
                          stroke="#323239"
                          stroke-width="3"
                        />
                        <path
                          d="M19 21L23 17M23 17L27 21M23 17V29"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </footer>

        <BuyPlan
          planCode={planCode}
          tenantId={tenantId}
          showPopUp={openPopup}
          setShowPopUp={setOpenPopup}
        />
      </div>
    </div>
  );
};

export default LandingPage;
